<template>
    <div class="right-bar__ruler settings">
        <h3 class="right-bar__header">{{ $t('translation.settings') }}</h3>

        <div class="settings__select multiselect-transparent">
            <label class="multiselect-transparent__label">{{ $t('translation.language') }}</label>
            <multiselect
                :value="language"
                placeholder=""
                :options="languages"
                :searchable="false"
                track-by="language"
                select-label=""
                label="language"
                :allow-empty="false"
                :custom-label="customLabel"
                class="multiselect-transparent__item"
                @select="onChangeLanguage"
            >
                <template slot="singleLabel" slot-scope="{ option }">
                    <span>{{ language }}</span>
                </template>
            </multiselect>
        </div>

        <div v-if="showLevels" class="settings__level level">
            <div class="col">
                <h4 class="level__header">{{ $t('translation.level') }}</h4>
                <ul class="level__list">
                    <li
                        class="level__item level__item--better"
                        :class="{
                            active: level === 1,
                        }"
                        @click="changeLevel(1)"
                    >
                        1
                    </li>
                    <li
                        class="level__item level__item--better"
                        :class="{
                            active: level === 2,
                        }"
                        @click="changeLevel(2)"
                    >
                        2
                    </li>
                    <li
                        class="level__item level__item--better"
                        :class="{
                            active: level === 3,
                        }"
                        @click="changeLevel(3)"
                    >
                        3
                    </li>
                    <li
                        class="level__item level__item--better"
                        :class="{
                            active: level === 4,
                        }"
                        @click="changeLevel(4)"
                    >
                        4
                    </li>
                    <li
                        class="level__item level__item--better"
                        :class="{
                            active: level === 5,
                        }"
                        @click="changeLevel(5)"
                    >
                        5
                    </li>
                </ul>
            </div>
            <div class="level__status">{{ $t(`translation.level${level}`) }}</div>
        </div>

        <div class="settings__background-color background-color">
            <h4 class="background-color__header">{{ $t('translation.backgroundColor') }}</h4>
            <div class="background-color__list">
                <span @click="changeBackgroundColor('#FFF6BE')" class="background-color__item background-color__yellow"></span>
                <span @click="changeBackgroundColor('#FFC2BE')" class="background-color__item background-color__coral"></span>
                <span @click="changeBackgroundColor('#FFBEF6')" class="background-color__item background-color__pink"></span>
                <span @click="changeBackgroundColor('#C8BEFF')" class="background-color__item background-color__plum"></span>
                <span @click="changeBackgroundColor('#BEFFBE')" class="background-color__item background-color__green"></span>
                <span @click="changeBackgroundColor('#BEFFFF')" class="background-color__item background-color__turquoise"></span>
                <span @click="changeBackgroundColor('#BEE9FF')" class="background-color__item background-color__sky"></span>
                <span @click="changeBackgroundColor('#BEC2FF')" class="background-color__item background-color__orchid"></span>
            </div>
        </div>

        <div v-if="showJoystickSettings">
            <div class="mt-5 settings__background-color background-color show-button">
                <h4 class="background-color__header">
                    {{ $t('translation.joystickNippleSettings') }}
                </h4>

                <div class="properties__direction mt-0 checkbox">
                    <span class="checkbox__before">
                        {{ $t('translation.joystickLeftNipple') }}
                    </span>
                    <label class="checkbox__container">
                        <input
                            @change="switchNipple"
                            :checked="!isDefaultNippleActive"
                            class="checkbox__input"
                            type="checkbox"
                        >
                        <span class="checkbox__item" />
                    </label>
                    <span class="checkbox__after">
                        {{ $t('translation.joystickRightNipple') }}
                    </span>
                </div>
            </div>
        </div>

        <div v-if="deviceIsEnableUpdateOs" class="mt-5 ml-3 show-button">
            <sidebar-item :withAction="true" :action="updateOS" :withText="true" icon="i-download" :text="$t('translation.updateSystem')" />
        </div>

        <div class="mt-5 ml-4 text-center show-button">
            {{ $t('translation.version') }}: {{ menuAppVersion }}
        </div>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect';
    import authMixin from '../../../mixins/auth';
    import menuMixin from '../../../mixins/menu';
    import deviceMixin from '../../../mixins/device';
    import SidebarItem from '../sidebar/SidebarItem.vue';
    import { saveAs } from 'file-saver';

    export default {
        props: {
            level: {
                required: true,
            },
            download: {
                required: false,
            },
            showLevels: {
                required: false,
            },
            showJoystickSettings: {
                type: Boolean,
                required: false,
                default: true,
            },
            isDefaultNippleActive: {
                // check is left nipple unlocked
                type: Boolean,
                required: false,
                default: true,
            },
        },
        mixins: [
            authMixin,
            deviceMixin,
            menuMixin,
        ],
        components: {
            Multiselect,
            SidebarItem,
        },
        methods: {
            switchNipple() {
                try {
                    if (this.isDefaultNippleActive) {
                        window.lockJoystickLeftNipple();
                        window.unlockJoystickRightNipple();
                    } else {
                        window.lockJoystickRightNipple();
                        window.unlockJoystickLeftNipple();
                    }
                } catch (e) {
                    console.log(e);
                }
            },
            changeLevel(level) {
                this.$emit('change-lavel', level);
            },
            changeBackgroundColor(color) {
                this.$emit('change-background-color', color);
            },
            onChangeLanguage({ language, direction }) {
                window.Swal({
                    title: this.$t('translation.languageDoYouWantSave'),
                    type: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: this.$t('translation.yes'),
                    cancelButtonText: this.$t('translation.no'),
                }).then((result) => {
                    if (result.value) {
                        try {
                            // jsBridge.saveFile(this.download);
                            console.log('save');

                            window.invokeCSCode('save');
                        } catch (e) {
                            let blob = new Blob([this.download], {
                                type: 'text/plain;charset=utf-8',
                            });

                            saveAs(blob, "golanix.glx");
                        }

                        setTimeout(() => {
                            this.lang(language, direction);
                        }, 5000);
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        this.lang(language, direction);
                    }
                });
            },
            customLabel({ language }) {
                if (!language) {
                    language = 'en';
                }

                return this.$t(`translation.${language}`);
            },
            updateOS() {
                try {
                    console.log('systemupdate');

                    window.invokeCSCode('systemupdate');
                } catch (e) {
                    // Code
                }
            },
        },
        data () {
            return {
                value: null,
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Code/rightbar/Settings.vue